<template>
  <v-container>
    <v-row
      align="center"
      justify="center"
    >
      <v-col md="6">
        <v-alert
          v-model="showError"
          type="error"
          transition="scale-transition">
          {{ errorMessage }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row
      align="center"
      justify="center"
    >
      <v-col md="6">
        <v-toolbar
          color="primary"
          dark
        >
          <v-toolbar-title class="ml-0 pl-3">R4 Login</v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-form
              ref="login-form"
              lazy-validation
            >
              <v-text-field
                v-model="username"
                label="Email"
                type='email'
                required />
              <v-text-field
                v-model="password"
                label="Password"
                type="password"
                autocomplete="on"
                required />
              <v-text-field
                v-if="showMfaInput"
                v-model="mfaChallengeUserCode"
                label="MFA Challenge Code"
                />
              <v-btn
                v-if="showMfaInput"
                color="primary"
                @click.prevent="verifyMfaChallenge"
                class="mr-2"
                type="submit">Verify MFA Token</v-btn>
              <v-btn
                v-if="!showMfaInput"
                color="primary"
                @click.prevent="loginUser"
                class="mr-2"
                type="submit">Login</v-btn>
              <v-btn @click.prevent="forgotPassword" v-if="!showMfaInput">Forgot Password?</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-footer
      :fixed="fixed"
      app
    >
      <v-col class="text-md-center" >
        <span v-html="$copyright"></span>
      </v-col>
    </v-footer>
  </v-container>
</template>

<script>
import { r4Client, r4Error } from '@/services'

export default {
  data: function () {
    return {
      username: '',
      password: '',
      showError: false,
      errorMessage: '',
      fixed: false,
      showMfaInput: false,
      mfaChallengeUserCode: null,
      mfaChallengeName: null,
      mfaChallengeParameters: null
    }
  },
  methods: {
    clearError: function () {
      this.showError = false
      this.errorMessage = ''
    },
    loginUser: function () {
      this.clearError()
      this.$store
        .dispatch('authenticateUser', {
          username: this.username,
          password: this.password
        })
        .then(authResponse => {
          if (authResponse.newPaswordRequired) {
            this.$router.push({ name: 'user_complete_registration_path' })
            return
          }

          if (authResponse.mfaChallengeRequired) {
            this.showMfaInput = true
            this.mfaChallengeName = authResponse.ChallengeName
            this.mfaChallengeParameters = authResponse.ChallengeParameters
            this.mfaSession = authResponse.Session
            return
          }
          // all conditionals pass, authenticated and ready
          this.$router.push({ name: 'dashboard_path' })
        })
        .catch(error => {
          if (error.code && error.code === 'UserNotFoundException') {
            this.errorMessage = 'Incorrect username or password.'
          } else {
            this.errorMessage = error.message
          }
          this.showError = true
        })
    },
    forgotPassword: function () {
      this.clearError()
      if (this.username) {
        r4Client(false).post('/api/v1/profile/reset_password', { email: this.username })
          .then((response) => {
            this.$router.push({ name: 'reset_forgotten_password_path', query: { username: response.data.data.username } })
          }).catch((error) => {
            this.showError = true
            this.errorMessage = 'Error resetting password. ' + r4Error(error).message
          })
      } else {
        this.showError = true
        this.errorMessage = 'Enter your email in the email field above and try again!'
      }
    },
    verifyMfaChallenge: function () {
      this.clearError()
      this.$store
        .dispatch('verifyMfaChallenge', {
          ChallengeName: this.mfaChallengeName,
          mfaChallengeUserCode: this.mfaChallengeUserCode,
          username: this.username,
          Session: this.mfaSession
        })
        .then(cognitoUser => {
          this.$logger.trace('>> verifyMfaChallenge cognitoUser', cognitoUser)
          this.$router.push({ name: 'dashboard_path' })
        })
        .catch(error => {
          this.showError = true
          this.errorMessage = error.message
        })
    }
  }
}
</script>

<style>
</style>
